<template>
  <div class="contract-list">
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="form.code" size="small" placeholder="投放编号" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-input v-model="form.bloggerName" size="small" placeholder="博主名称" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.contractName" size="small" placeholder="合同名称" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.contractCode" size="small" placeholder="合同编码" @keyup.enter.native="onSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select style="width:100%;" v-model="form.paymentStatus" clearable placeholder="审批状态" @keyup.enter.native="onSearch">
          <el-option label="待审批" :value="0"></el-option>
          <el-option label="审批中" :value="1"></el-option>
          <el-option label="审批通过" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          style="width:280px;"
          v-model="publicTimeData"
          type="datetimerange"
          range-separator="~"
          start-placeholder="最早发布时间"
          end-placeholder="最晚发布时间">
        </el-date-picker>
      </el-form-item>
        
      <el-form-item>
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">投放总数：{{ page.total }}条</div>
        <div>
          <el-button type="primary" size="small" @click="batchImportClick">批量导入</el-button>
          <el-badge style="margin:0 25px;" :value="multiSelectList.length" class="item">
            <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="batchClick">批量提交付款</el-button>
          </el-badge>
          <el-button type="primary" size="small" @click="onExport">导出</el-button>
        </div>
      </div>
      <el-table v-loading="tableLoading" :data="tableData" size="small" >
        <el-table-column label="投放编号" min-width="120" prop="code" align="center"></el-table-column>
        <el-table-column label="博主名称" prop="bloggerName" min-width="160" align="center">
          <template slot-scope="scope">
            <div class="account-wrap">
              <div class="avatar-out">
                <div class="avatar-in">
                  <div class="img-wrap" v-if="scope.row.avatar">
                    <!--有头像-->
                    <img v-if="scope.row.avatar.indexOf('/qr/code') !== -1" :src="scope.row.avatar" onerror="javascript:this.src='/img/media/wechat_default.png';" class="avatar is-code">
                    <img v-else :src="scope.row.avatar" onerror="javascript:this.src='/img/media/weibo_default.png';" class="avatar">
                  </div>
                  <div class="img-wrap" v-else>
                    <img src="/img/media/weibo_default.png" class="avatar">
                  </div>
                </div>
              </div>
              <div class="info-wrap">
                <el-tooltip :content="scope.row.bloggerName" placement="bottom" effect="light">
                  <div class="nickname"><span>{{ scope.row.bloggerName }}</span></div>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="平台" prop="mediaType" align="center">
          <template slot-scope="scope">
            {{ mediaConfig.getAppointed("media_ch", scope.row.mediaType, '') }}
          </template>
        </el-table-column>
        <el-table-column label="关联合同" prop="contract" align="center" min-width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.contractName">
              <p>{{ scope.row.contractName }}</p>
              <p>{{ scope.row.contractCode }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
        <el-table-column label="品牌" prop="brandName" align="center"></el-table-column>
        <el-table-column label="发布日期" min-width="120" prop="publishTime" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishTime && scope.row.publishTime.split(' ')[0] }}
          </template>
        </el-table-column>
        <el-table-column label="执行价" prop="executePrice" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.executePrice) }}
          </template>
        </el-table-column>
        <el-table-column label="投放状态" prop="status" align="center">
          <template slot-scope="scope">
            {{ deliveryConfig.getAppointed("delivery_status", scope.row.status, '') }}
          </template>
        </el-table-column>
        <el-table-column label="结算状态" prop="settleStatus" align="center">
          <template slot-scope="scope">
            {{ deliveryConfig.getAppointed("settle_status", scope.row.settleStatus, '') }}
          </template>
        </el-table-column>
        <el-table-column label="其他金额（原始）" prop="otherPrice" align="center">
        </el-table-column>
        <el-table-column label="其他费用备注（原始）" prop="otherPriceRemark" align="center"></el-table-column>
        <el-table-column label="其他金额" prop="payOtherPrice" align="center">
        </el-table-column>
        <el-table-column label="备注" prop="otherRemark" align="center"></el-table-column>
        <el-table-column prop="status" align="center" label="审批状态">
          <template slot-scope="scope">
            <div>{{scope.row.paymentStatus == 0?"待提交":scope.row.paymentStatus == 1?"审批中":scope.row.paymentStatus == 2?"审批通过":"审批不通过"}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <!-- 进行中 -->
            <!-- 已结案,已关闭,结案审批中,关闭审批中 -->
            <div>
              <el-button type="text" size="small" @click="toShow(scope.row.id)">查看</el-button>
              <el-button v-if="(scope.row.paymentStatus == 0 || scope.row.paymentStatus == 3)&&scope.row.isShopCar==''" type="text" size="small" @click="openTrans(scope.row)">调整</el-button>
              <!-- todo 修改判断，查询的list中增加一个判断标记，初始化为0 则显示加入购物车，加入后修改为1 -->
              <el-button v-if="(scope.row.paymentStatus == 0 || scope.row.paymentStatus == 3)&&scope.row.isShopCar==''" type="text" size="small" @click="addShopcar(scope.row)">加入购物车</el-button>
              <el-button v-if="(scope.row.paymentStatus == 0 || scope.row.paymentStatus == 3)&&scope.row.isShopCar!=''" type="text" size="small" @click="subShopcar(scope.row)">删除购物车</el-button>
              
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div><!-- 分页 -->
      <!-- 购物车 -->
      <shopCar ref="shopCar" :multiSelectList="multiSelectList" :tableData="tableData" :contractValue="contractValue" @payInfoSave="payInfoSave" :contractDialog="contractDialog" @payInfoClose="payInfoClose"></shopCar>
    </div>
    <el-dialog :title="dialogTitle" width="30%" :visible.sync="dialogTableVisible">
      <el-form v-if="dialogTitle==='调整项'" label-position="left" :model="transForm" ref="transForm" label-width="100px" class="demo-ruleform">
        <el-form-item label="其他金额：">
          <el-input v-model="transForm.payOtherPrice"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="transForm.otherRemark" rows="4" show-word-limit placeholder="请输入调整原因" maxlength="100"></el-input>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="saveClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisible = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 批量修改 -->
    <el-dialog
      title="批量修改"
      :visible.sync="dialogVisible"
      width="50%">
      <el-form v-if="promptShow" label-position="top" size="small" :model="ruleForm" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <div>
          <el-form-item style="height:70px;" label="批量修改模板（其他）" prop="path" class="block-form-item w-25">
            <el-upload style="margin-right:60px;" class="upload-demo" :action="'https://upload-z2.qiniup.com'" :before-upload="getBeforeUpload">
              <el-button type="primary">上传文档</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item style="height:70px;" label="批量修改模板（其他）" prop="path" class="block-form-item w-70">
            <a class="link chaochu" href="javascript:void(0);" @click="downloadFile(moban, '批量修改模板（其他）')" download="批量修改模板（其他）">批量修改模板（其他）.xlsx</a>
          </el-form-item>
        </div>
        <div style="color:#409eff;" v-if="fileData">{{fileData.name}}</div>
        <div class="anniuFlex" style="margin-top:20px;text-align:center;">
					<el-button style="margin-right:60px;" v-if="beforeShow" @click="before_UploadOne" type="primary">导 入</el-button>
          <el-button type="primary" style="margin-right:60px;" v-else :loading="true">导入中</el-button>
          <el-button plain @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-form>
      <div v-else style="margin-top:-10px;text-align:center;">
        <div v-if="successShow==1" class="el-icon-success" style="font-size:60px;color:#67c23a;"></div>
        <div v-if="successShow==2" class="el-icon-error" style="font-size:60px;color:#f5212e;"></div>
        <div v-if="successShow==3" class="el-icon-warning" style="font-size:60px;color:#faad14;"></div>
        <h4 style="font-size:20px;">{{successShow==1?'导入成功':successShow==2?'导入失败':'部分导入成功'}}</h4>
        <div v-if="successShow == 3" style="padding-bottom:20px;">请导出失败投放记录，检查导入格式后再重新导入</div>
        <div class="box-flex">
          <div>导入成功：{{uploadData.successCount}}条</div>
          <div style="margin-left:100px;">导入失败：{{uploadData.failCount}}条</div>
        </div>
        <div>
          <el-button v-if="successShow == 1" @click="dialogVisible = false" type="primary" style="margin-right:60px;" size="small">继续导入</el-button>
          <!-- <el-button type="primary" @click="exportFailure" style="margin-right:60px;">导出失败记录</el-button> -->
          <el-button v-else type="primary" size="small" @click="exportWord" style="margin-right:60px;">导出失败记录</el-button>
          <el-button plain size="small" @click="dialogVisible = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="加购物车提醒" :visible.sync="shopcarVisible" width="30%">
      <div>
        <div style="margin-bottom: 10px">加购物车条件：</div>
        <div class="invoiceList">
          <span>1，投放记录未提交付款申请</span>
          <i v-if="addShopcarCondition.isSubmit" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList">
          <span>2，投放记录未加入购物车</span>
          <i v-if="addShopcarCondition.isAddShopcar" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>3，投放记录已计算出博主金额（请检查博主及资源审批状态，博主税率，分成方式，投放时间及对应时间范围内的分成比例）</span>
          <i v-if="addShopcarCondition.isBloggerIncome" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
      </div>
    </el-dialog>

    <!-- 导入投放记录 -->
  </div>
</template>

<script>
import xlsx from "xlsx";
import validate from "@/util/validate";
import util from "@/util/util";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/contract";
import { deliveryConfig } from "@/const/config/delivery";
import {
  listDelivery,
  exportDelivery,
  delDelivery,
  relateContract,
  putRecordImport
} from "@/api/business/delivery";
import { mapGetters } from "vuex";
import shopCar from "../../component/shopCarOther";
import { qiniuToken } from "@/api/index";
import * as qiniu from "qiniu-js";
import { otherPayConfirm,listOtherPayInfo,submitOtherPayInfo,recordOtherImport,
  subShopcar ,addShopcar,getOtherShopcarList } from "@/api/pay/api";
export default {
  components: {
    shopCar
  },
  data() {
    return {
      beforeShow:true, //导入按钮控制
      moban:"/files/批量修改模板（其他）.xlsx",
      mediaConfig: mediaConfig,
      contractConfig: contractConfig,
      deliveryConfig: deliveryConfig,
      contractDialog:false,
      dialogVisible:false,
      changeForm:{
        path:"",
        name:"",
        desc:"",
      },
      form: {
        code: "",
        publicStartTime:"" ,
        publicEndTime:"" ,
        bloggerName: "",
        contractName:"",
        contractCode:"",
        customerName:"",
        paymentStatus:"" ,
      },
      transForm:{
        id:"",
        otherRemark:"",
        payOtherPrice:"",
      },
      dialogTableVisible:false,
      dialogTitle:"",
      publicTimeData:[],

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      paymentInfo:{
        payAccount:"",
        payAccountNum:"" ,
        payType:4 ,
        payReason:"",
        payDepart:"",
      },

      addShopcarCondition:{
        isSubmit:false ,
        isAddShopcar:false,
        isAllBack:false,
        isBloggerIncome:false,
      },
      shopcarVisible:false,

      tableData: [],
      tableLoading: false,
      multiSelectList:[],
      contractId:"",
      batchType:"",
      contractValue:{
        submitLoading: false,  
      },
      fileData:"",
      ruleForm:{},
      promptShow:true,
      successShow:"",
      uploadData:"",
      sheetHeader:["*账号平台","*账号名称","*关联合同编号","品牌名称","产品名称","发布形式","发布日期","执行价","投放链接","外部平台","外部平台任务ID","*结算状态","结算金额","结算日期","收款方","收款日期","分成基数金额","固定返点","最终返点"]
    };
  },
  mounted() {
    this.getShopcar() ;
  },
  methods: {
			
    //提交博主结算付款申请
    payInfoSave(item){
      this.paymentInfo.paymentListVOs = this.multiSelectList ;
      this.paymentInfo.payAccount = item.payAccount ;
      this.paymentInfo.payAccountNum = item.payAccountNum ;
      this.paymentInfo.depositBank = item.depositBank ;
      this.paymentInfo.payReason = item.payReason ;
      this.paymentInfo.payDepart = item.payDepart ;
      submitOtherPayInfo(this.paymentInfo).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '付款提交成功!',
            type: 'success'
          });
          this.multiSelectList = [] ;
          this.contractDialog = false ;
          this.getList();
        }
        this.contractValue.submitLoading = false ;
        console.log('=======付款提交成功=====',res)
      })
      .catch((error) => {
        this.contractValue.submitLoading = false;
      });
    },
    //批量关联合同
    batchClick(){
      this.contractDialog = true;
    },
    payInfoClose(){
      this.contractDialog = false;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        code: "",
        publicStartTime:"" ,
        publicEndTime:"" ,
        bloggerName: "",
        contractName:"",
        contractCode:"",
        customerName:"",
      };
      this.publicTimeData = [] ;
      this.onSearch();
    },
    // 搜索
    onSearch() {
      if(this.publicTimeData){
        this.form.publicStartTime = this.publicTimeData[0]
        this.form.publicEndTime = this.publicTimeData[1]
      }else{
        this.form.publicStartTime = ""
        this.form.publicEndTime = ""
      }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      this.tableLoading = true;
      listOtherPayInfo(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          for(var i = 0 ; i < res.data.length; i++){ 
              var putInCode = res.data[i].code ;

              var index2 = this.multiSelectList.findIndex(item => {
                if ( item.code == putInCode) {
                    res.data[i].isShopCar = "1" ;
                    return true;
                }
              });

          }
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },


    // 获取列表
    getShopcar() {
      let queryObj = {} ;
      queryObj.payType = 4 ;
      this.tableLoading = true;
      getOtherShopcarList(queryObj)
        .then((res) => {
          this.multiSelectList = res.data || [];
          this.getList() ;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.multiSelectList = [];
          this.tableLoading = false;
        });
    },



    /**
     * 导出
     */
    onExport() {
      let queryObj = validate.removeFilterNull(this.form);
      exportDelivery(queryObj).then((res) => {
        const blob = new Blob([res.data]);
        let fileName = res.headers["content-disposition"].split("filename=")[1];
        fileName = decodeURI(fileName);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          const linkNode = document.createElement("a");
          linkNode.download = fileName; //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none";
          linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click(); //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
        }

        setTimeout(() => {
          this.$message.success("导出成功，等待文件下载完毕");
        }, 500);
      });
    },
    /**
     * 跳转到查看页
     */
    toShow(id) {
      let router = this.$router.resolve({
        path: "/pay/blogger/show",
        query: { id,type:'show' },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },

    addShopcar(obj){
      obj.payType = 4 ;
      addShopcar(obj).then(res=>{
        if(res.code === 1){
          this.addShopcarCondition = res.data ;
          if(this.addShopcarCondition.isAddShopcar
              &&this.addShopcarCondition.isBloggerIncome&&this.addShopcarCondition.isSubmit){
            this.shopcarVisible = false ;
            this.$message({
              message: '加入购物车成功!',
              type: 'success'
            });
            this.multiSelectList.push(obj) ;
            console.log("tableData=",this.tableData);
            var index = this.tableData.findIndex(item => {
              if ( item.id == obj.id) {
                  return true;
              }
            });
            this.tableData[index].isShopCar = "1" ;
          }else{
            this.shopcarVisible = true ;

          }
        }
      })

    },

    subShopcar(obj){
      obj.payType = 4 ;

      subShopcar(obj).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '删除购物车成功!',
            type: 'success'
          });
          var index = this.multiSelectList.findIndex(item => {
          if ( item.id == obj.id) {
              return true;
          }
          })
          this.multiSelectList.splice(index,1);

          var index2 = this.tableData.findIndex(item => {
            if ( item.id == obj.id) {
                return true;
            }
          });
          this.tableData[index2].isShopCar = "" ;
        }
      })

    },

    //打开调整输入框
    openTrans(obj){
      this.dialogTitle = '调整项' ;
      this.dialogTableVisible = true ;
      console.log("======"+obj);
      this.transForm.id = obj.id;
      this.transForm.payOtherPrice = obj.payOtherPrice;
      this.transForm.otherRemark = obj.otherRemark;
    },


    //保存确认调整项
    saveClick(){
      otherPayConfirm(this.transForm).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '确认调整项成功!',
            type: 'success'
          });
          this.dialogTableVisible = false
          this.getList();
        }
        console.log('=======确认调整项成功=====',res)
      })
    },

    batchImportClick(){
      this.fileData = "";
      this.promptShow = true;
      this.dialogVisible = true;
    },
    //上传文件成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    //上传文件失败
    uploadError(res, file) {
      console.log("error", res, file);
    },
    //文件上传
    beforeUpload(file) {
      if (file.size > 500 * 1024 * 1024) {
        this.$message.error("文件大小不能超过500M");
        return false;
      }
      qiniuToken()
        .then((res) => {
          let that = this;
          let fileName = Date.now() + file.name;
          var observable = qiniu.upload(file, fileName, res.data);
          observable.subscribe({
            next(res) {},
            error(error) {
              this.$message.error("上传失败");
            },
            complete: (complete) => {
              let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
              this.$set(this.ruleForm, "name", file.name);
              this.$set(this.ruleForm, "path", qiniuBaseUrl + complete.key);
            },
          });
        })
        .catch((error) => {});
      return false;
    },


    //导出开票列表
			exportWord(){
				var data = this.uploadData.failDataList
        let dataTable = []
        for (let i in data) {
          let obj = {
            '投放记录编码': data[i].putInCode,
            '其他金额': data[i].payOtherPrice,
            '其他备注': data[i].otherRemark,
            '失败信息':data[i].reason
          }
          dataTable.push(obj);
				}
				  //生成表格
				  var sheet = xlsx.utils.json_to_sheet(dataTable);
				  var tmpdata = xlsx.utils.sheet_add_json(sheet, dataTable, { origin: "A2" });
				  //给A1单元格赋值
				  tmpdata["A1"] = {
				    t: "s",
				    v: `批量修改（其他）导入文档说明：
1，投放记录编码：【必填】
2，其他金额：【必填】
3，其他备注：
`
				  };
				  // 设置A1标题字体样式
				  tmpdata["A1"].s = {
            font: { sz: 10},
            alignment: { vertical: "center", wrapText: true },
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "00b050" }},
				  };
				  //单元格合并
				  tmpdata["!merges"] = [{ 
				    //合并单元格 index都从0开始
				    s: { //s开始
				      c: 0, //开始列
				      r: 0 //开始行
				    },
				    e: { //e结束
				      c: 3, //结束列
				      r: 0 //结束行
				    }
				  }]
          // 设置B2单元格样式
          let colWidthList = []
          this.sheetHeader.forEach((v, index) => {
            tmpdata[this.convert10to26(index + 1) + 2] = {
              t: "s", //类型 s字符串 n数字
              v:v,
              s: {
                font: { sz: 11, color: { rgb: "ff0000" }},
                alignment: { horizontal: "center", vertical: "center", wrapText: true },
                fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "fcd5b4" }}
              }
            }
            colWidthList[index] = index==2 || index==10 || index==16?{ wpx: 100 }:{ wpx: 80 };
          })
        tmpdata['!cols'] = colWidthList;
        tmpdata['!rows'] = [{ hpx: 1000 }];
				const filename = `批量修改（其他）失败数据`
        console.log(tmpdata)
				this.openDownloadDialog(this.sheet2blob(tmpdata), `${filename}.xlsx`);
			},
			sheet2blob(sheet, sheetName) {
			  sheetName = sheetName || 'sheet1';
			  var workbook = {
			    SheetNames: [sheetName],
			    Sheets: {},
			  };
			  workbook.Sheets[sheetName] = sheet; // 生成excel的配置项
			
			  var wopts = {
			    bookType: 'xlsx', // 要生成的文件类型
			    bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
			    type: 'binary'
			  };
			  var wbout = XLSXStyle.write(workbook, wopts);
			  var blob = new Blob([s2ab(wbout)], {
			    type: "application/octet-stream"
			  }); // 字符串转ArrayBuffer
			  function s2ab(s) {
			    var buf = new ArrayBuffer(s.length);
			    var view = new Uint8Array(buf);
			    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
			    return buf;
			  }
			  return blob;
			},
			
			openDownloadDialog(url, saveName) {
			  let href = URL.createObjectURL(url)
			  let a = document.createElement('a');
			  a.href = href;
			  a.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
			  document.body.appendChild(a)
			  a.click()
			  document.body.removeChild(a)
			  setTimeout(() => {
			    URL.revokeObjectURL(url)
			  }, 200);
			},
      convert10to26(num){
        var str = "";
        while (num > 0) {
          var m = num % 26;
          if (m == 0) {
            m = 26;
          }
          str = String.fromCharCode(m + 64) + str;
          num = (num - m) / 26;
        }
        return str;
    },
    //导出失败数据
    exportFailure(){
      const ExportJsonExcel = require('js-export-excel')
      var option={};
      option.fileName = '投放记录失败数据'
      option.datas=[{
        sheetData:this.uploadData.failDataList,//data就是传入的后台数据 作为的参数
        sheetHeader:this.sheetHeader//自定义表头
      }]
      var toExcel=new ExportJsonExcel(option);
      toExcel.saveExcel();
    },
    before_UploadOne(){
      if(this.fileData){
        this.beforeShow = false;
        let formData = new FormData();
        formData.append("file", this.fileData);
        recordOtherImport(formData).then(res=>{
          this.beforeShow = true;
          console.log('======导入数据返回======',res)
          if(res.code === 1){
            //文档没数据
            if(res.data.failCount == 0 && res.data.successCount == 0){
              this.$message.warning('导入模版数据为空,请上传正确的模版数据!');
              this.dialogVisible = false;
              this.getList();
              return;
            }
            this.uploadData = res.data;
            // 导入成功进入
            if(res.data.failCount == 0){
              this.promptShow = false;
              this.successShow = 1;
              this.getList();
              return
            }
            //导入失败进入
            if(res.data.successCount == 0){
              this.promptShow = false;
              this.successShow = 2;
              this.getList();
              return
            }
            //部分导入成功失败进入
            if(res.data.failCount>0 && res.data.successCount>0){
              this.promptShow = false;
              this.successShow = 3;
              this.getList();
              return
            }
          }
        })
      }else{
        this.beforeShow = true;
        this.$message({
          message: '请上传投放记录模版!',
          type: 'warning'
        });
      }
    },
    getBeforeUpload(file){
      this.fileData = file
      console.log('======44444=======',file)
    },
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>

<style lang="scss" scoped>
.anniuFlex{
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-text—flex{
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box-flex{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
//账号名称
.account-wrap {
  display: flex;
  cursor: pointer;
  //头像
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
  //基础信息
  .info-wrap {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 12px;
    text-align: left;
    .nickname {
      max-width: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.block-form-item {
  &.w-25 {
    display: inline-block;
    width: 24%;
    margin-right: 1%;
    height: 64px;
  }
  &.w-70 {
    display: inline-block;
    width: 70%;
    margin-right: 1%;
    height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
</style>